var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "56.372 51.1 87.854 98.4",
    viewBox: "56.372 51.1 87.854 98.4",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.3 132l-30.4-45.1c-2.1-3.2-3.3-6.9-3.3-10.8V53.4H92v22.7c0 3.8-1.1 7.6-3.3 10.8L58.3 132c-5 7.5.3 17.5 9.3 17.5h65.3c9.1 0 14.4-10 9.4-17.5z",
    fill: "#5E17EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 107.9h-13l-13.1 19.4c-1.8 2.7.1 6.2 3.3 6.2h32.4c3.2 0 5.1-3.6 3.3-6.2l-12.9-19.4z",
    fill: "#FEC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1 51.1H88.6c-4.5 0-8.2 3.7-8.2 8.2 0 4.5 3.7 8.2 8.2 8.2h23.5c4.5 0 8.2-3.7 8.2-8.2 0-4.5-3.7-8.2-8.2-8.2z",
    fill: "#5E17EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.da35b2bbdc2adf846b49888d77ddd7c8.svg";
export { ForwardRef as ReactComponent };